import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './main.routes';

export class MainController {

  awesomeThings = [];
  newThing = '';
  
  constructor($http) {
    this.$http = $http;
  }

  $onInit() {
  }
}

export default angular.module('bfastCaptureManagerApp.main', [uiRouter])
  .config(routing)
  .component('main', {
    template: require('./main.html'),
    controller: MainController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/main/main.component.js